import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SideBarComponent } from '@shared/components/side-bar/side-bar.component';
import { TopBarComponent } from '@shared/components/top-bar/top-bar.component';
import { SidebarStateService } from '@core/services/sidebar-state.service';
import { OcorrenciaNotificationService } from '@core/services/ocorrencia-notification.service';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, CommonModule, SideBarComponent, TopBarComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent implements OnInit, OnDestroy {
  readonly sidebar = inject(SidebarStateService);
  private readonly notifications = inject(OcorrenciaNotificationService);

  ngOnInit(): void {
    void this.notifications.connect().catch(() => {
      // O canal em tempo real e opcional; o resto do admin continua disponivel.
    });
  }

  ngOnDestroy(): void {
    void this.notifications.disconnect();
  }
}
